var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveryMotorcycle = function SvgDeliveryMotorcycle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2055 8.14286C27.2055 6.41429 25.7652 5 24.0049 5H19.2039V8.14286H24.0049V12.3071L18.4358 19.1429H12.8026V11.2857H6.4013C2.86458 11.2857 0 14.0986 0 17.5714V22.2857H3.20065C3.20065 24.8943 5.34509 27 8.00163 27C10.6582 27 12.8026 24.8943 12.8026 22.2857H19.9721L27.2055 13.4071V8.14286ZM8.00163 23.8571C7.12145 23.8571 6.4013 23.15 6.4013 22.2857H9.60195C9.60195 23.15 8.88181 23.8571 8.00163 23.8571Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80098 6.57156H12.8026V9.71441H4.80098V6.57156Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.199 17.4045C24.5425 17.4045 22.398 19.5103 22.398 22.1188C22.398 24.7274 24.5425 26.8331 27.199 26.8331C29.8556 26.8331 32 24.7274 32 22.1188C32 19.5103 29.8556 17.4045 27.199 17.4045ZM27.199 23.6903C26.3188 23.6903 25.5987 22.9831 25.5987 22.1188C25.5987 21.2545 26.3188 20.5474 27.199 20.5474C28.0792 20.5474 28.7993 21.2545 28.7993 22.1188C28.7993 22.9831 28.0792 23.6903 27.199 23.6903Z",
    fill: "currentColor"
  })));
};
export default SvgDeliveryMotorcycle;